import React from 'react';
import './mensuration.css';
import Heading from '../../../../Miscs/Heading/Heading';

const Mensuration = () => {
	return (
		<>
			<div className="mensuration">
				<Heading>Mensuration</Heading>
			</div>
		</>
	);
};

export default Mensuration;
